import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export default function UnauthorizedPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <Card className="w-full max-w-md text-center">
        <CardContent className="pt-6 space-y-4">
          <AlertTriangle className="w-16 h-16 text-amber-500 mx-auto" />
          <h1 className="text-2xl font-heading font-bold text-primary">Access Denied</h1>
          <p className="text-secondary">You don't have permission to view this page.</p>
          <Link to="/dashboard"><Button>Go to Dashboard</Button></Link>
        </CardContent>
      </Card>
    </div>
  );
}
